import {
  BoxSpg,
  GridContainer,
  GridItem,
  THUNK_STATUS,
  TableSkeleton,
  AlertSpg,
  TableButton,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { useEffect } from "react";
import { filterArUniEntryRequests } from "../../../../../store/redux/slice/Request/arUniEntryRequests";
import ARUniEntryRequestListTable from "./list/ARUniEntryRequestListTable";
import { ARUniEntryRequestStatus } from "../../../../../utils/constants";

const ARUniEntryRequestList = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const arUniEntryRequestFilter = useAppSelector((state) => {
    return state.Request.arUniEntryRequestFilter;
  });

  const arUniEntryRequests = useAppSelector((state) => {
    return state.Request.arUniEntryRequests;
  });

  useEffect(() => {
    dispatch(filterArUniEntryRequests(arUniEntryRequestFilter));
  }, [dispatch, arUniEntryRequestFilter]);

  const createOptions = (record) => {
    return (
      <>
        <TableButton type={"view"} title={t("l.btn.view")} to={"/ar-uni-entry-request/list/view?id=" + record.id} />
        {(record.requestStatus?.id === ARUniEntryRequestStatus.DRAFT ||
          record.requestStatus?.id === ARUniEntryRequestStatus.ACCEPTED) && (
          <TableButton type={"edit"} title={t("l.btn.edit")} to={"/ar-uni-entry-request/list/edit?id=" + record.id} />
        )}
      </>
    );
  };

  return (
    <BoxSpg>
      <GridContainer mt={0}>
        <GridItem sm={12} md={12} pr={0}>
          {(arUniEntryRequests.list.status === THUNK_STATUS.PENDING ||
            arUniEntryRequests.list.status === THUNK_STATUS.INITIAL) && <TableSkeleton />}
          {arUniEntryRequests.list.status === THUNK_STATUS.REJECTED && (
            <AlertSpg severity={"error"}>{t("m.generic.error.service.fail")}</AlertSpg>
          )}
          {arUniEntryRequests.list.status === THUNK_STATUS.FULFILLED && (
            <ARUniEntryRequestListTable createOptions={createOptions} />
          )}
        </GridItem>
      </GridContainer>
    </BoxSpg>
  );
};
export default ARUniEntryRequestList;
